import {etsySettings} from '@coolcolduk/etsy';
import {fillerArray} from '@coolcolduk/util';
import {z} from 'zod';
import {zEtsySku} from '../validation/zEtsySku';
import {zEtsyTag} from '../validation/zEtsyTag';
import {zEtsyTitle} from '../validation/zEtsyTitle';

export const ETSY_BULK_CREATE_CSV_HEADER = [
  'title',
  'sku',
  ...fillerArray((i) => `tag${i + 1}`, etsySettings.listing.tags.maxCount),
  ...fillerArray((i) => `image_url_${i + 1}`, etsySettings.listing.image.maxNumber),
];

export type EtsyBulkCreateCsvData = {
  title: string;
  sku?: string;
  tag1?: string;
  tag2?: string;
  tag3?: string;
  tag4?: string;
  tag5?: string;
  tag6?: string;
  tag7?: string;
  tag8?: string;
  tag9?: string;
  tag10?: string;
  tag11?: string;
  tag12?: string;
  tag13?: string;
  image_url_1?: string;
  image_url_2?: string;
  image_url_3?: string;
  image_url_4?: string;
  image_url_5?: string;
  image_url_6?: string;
  image_url_7?: string;
  image_url_8?: string;
  image_url_9?: string;
  image_url_10?: string;
};

export const zEtsyBulkCreateCsvData = z.object({
  title: zEtsyTitle,
  sku: zEtsySku.optional().transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  tag1: zEtsyTag.optional().transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  tag2: zEtsyTag.optional().transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  tag3: zEtsyTag.optional().transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  tag4: zEtsyTag.optional().transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  tag5: zEtsyTag.optional().transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  tag6: zEtsyTag.optional().transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  tag7: zEtsyTag.optional().transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  tag8: zEtsyTag.optional().transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  tag9: zEtsyTag.optional().transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  tag10: zEtsyTag.optional().transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  tag11: zEtsyTag.optional().transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  tag12: zEtsyTag.optional().transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  tag13: zEtsyTag.optional().transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  image_url_1: z
    .string()
    .optional()
    .transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  image_url_2: z
    .string()
    .optional()
    .transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  image_url_3: z
    .string()
    .optional()
    .transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  image_url_4: z
    .string()
    .optional()
    .transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  image_url_5: z
    .string()
    .optional()
    .transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  image_url_6: z
    .string()
    .optional()
    .transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  image_url_7: z
    .string()
    .optional()
    .transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  image_url_8: z
    .string()
    .optional()
    .transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  image_url_9: z
    .string()
    .optional()
    .transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
  image_url_10: z
    .string()
    .optional()
    .transform((val) => (val === undefined || val === '' ? undefined : val.trim())),
}) satisfies z.ZodType<EtsyBulkCreateCsvData>;

/**
 * create a etsy bulk create csv header
 * @returns
 */
export default function getEtsyBulkCreateCsvHeader() {
  return ETSY_BULK_CREATE_CSV_HEADER.join(',');
}
